import React from 'react'
import { LineSeries, PointTooltipProps } from '@nivo/line'
import { Box, Paper } from '@material-ui/core'

type Props = PointTooltipProps<LineSeries> & {
  xFormatter: (time: number) => string
  yFormatter: (value: number) => string
}

export function Tooltip({
  point,
  xFormatter,
  yFormatter,
}: Props): React.ReactElement {
  const xValue = Number(point.data.x)
  const yValue = Number(point.data.y)

  return (
    <Paper>
      <Box p={1}>
        <Box>{point.seriesId}</Box>
        <Box>
          {xFormatter(xValue)}: {yFormatter(Number(yValue))}
        </Box>
      </Box>
    </Paper>
  )
}
